import { Circle } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { PhraseStatus } from "../../../api/phrasebook";
import { phraseColorByStatus } from "./colors";

export default function PhrasesLegend() {
  return (
    <Box
      sx={{
        py: 1,
        px: 2,
        display: "flex",
        flexDirection: "row",
        gap: 1,
        cursor: "default",
      }}
    >
      <Typography
        variant="body2"
        sx={{
          fontSize: "0.875rem",
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Circle
          sx={{
            fontSize: "0.75rem",
            color: phraseColorByStatus[PhraseStatus.UNREVIEWED],
          }}
        />
        <span>Not reviewed</span>
      </Typography>
      <Typography
        variant="body2"
        sx={{
          fontSize: "0.875rem",
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Circle
          sx={{
            fontSize: "0.75rem",
            color: phraseColorByStatus[PhraseStatus.INTERNALLY_REVIEWED],
          }}
        />
        <span>Internally reviewed</span>
      </Typography>
      <Typography
        variant="body2"
        sx={{
          fontSize: "0.875rem",
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Circle
          sx={{
            fontSize: "0.75rem",
            color: phraseColorByStatus[PhraseStatus.EXTERNALLY_REVIEWED],
          }}
        />
        <span>Externally reviewed</span>
      </Typography>
    </Box>
  );
}
